import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=215946f4&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=215946f4&prod&lang=scss"
import style1 from "./Question.vue?vue&type=style&index=1&id=215946f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215946f4",
  null
  
)

export default component.exports